export enum AxisCellType {
  AXIS_ROW_CELL = 'axisRowCell',
  AXIS_COL_CELL = 'axisColCell',
  AXIS_CORNER_CELL = 'axisCornerCell',
}
